<template>
  <div id="app">
    <div v-if="!isLoginPage">
      <div class="header-notif">
        کاربر گرامی، نسخه جدید سامانه واداروم در دسترس قرار گرفت، توجه داشته باشید که از تاریخ (29
        آبان ماه 1403) نسخه فعلی از دسترس خارج و برگزاری جلسات صرفأ در
        <a href="https://vadaroom.ec.iau.ir/v2" target="_blank"> نسخه جدید </a>
        ممکن خواهد بود.
      </div>
    </div>

    <!-- <router-view :key="appIndex"/> -->
    <router-view />
    <!-- <div class="material f-c-c w-100">
      <b-img :src="require(`@/assets/images/logo-azadu-iauec.svg`)"></b-img>
      <div class="text f-c-c">کلیه حقوق مادی و معنوی متعلق به دانشگاه آزاد اسلامی واحد الکترونیکی می باشد.</div>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      appIndex: 0,
    };
  },
  created() {
    document.title = "وادا روم";
  },
  computed: {
    // ...mapState({
    //   ltrRtl: (state) => state.login.ltrRtl,
    // }),
    isLoginPage() {
      return (
        this.$route.path === "/" ||
        this.$route.path === "/login" ||
        this.$route.path === "/login-with-pass"
      );
    },
  },
  methods: {
    ...mapActions("gap", ["setClickTabNavFunction"]),
  },
  watch: {
    $route() {
      this.appIndex = this.appIndex + 1;
      this.setClickTabNavFunction(0);
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.header-notif {
  padding: 2rem;
  background-color: #16a34a;
  text-align: center;
  font-size: 1rem;
  color: white;
  a {
    color: blue;
  }
}

@media (min-width: 1400px) {
  .header-notif {
    font-size: 1.1rem;
  }
}
</style>
